// extracted by mini-css-extract-plugin
export default {"table":"ResultsTable-module__table__ZJ2qE","button":"ResultsTable-module__button__beLjX"};